import { ReactNode } from "react";
import { Badge } from "@mui/material";

interface NotificationDotBadgeProps {
    show: boolean;
    children: ReactNode;
}

function NotificationDotBadge(props: NotificationDotBadgeProps) {
    if (!props.show) {
        return props.children;
    }

    return (
        <Badge sx={{ "& .MuiBadge-badge": { backgroundColor: "#FA9CAE" } }} variant="dot">
            {props.children}
        </Badge>
    );
}

export default NotificationDotBadge;
